module.exports = __webpack_public_path__ + "static/media/ocean.4e8ed471.png";